<template>
  <v-container class="mass" fluid>
    <v-row align="center">
      <v-col cols="auto" class="mr-auto">
        <h1 style="margin-bottom: 10px">Массовые функции</h1>
      </v-col>
    </v-row>
    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
    <v-card flat class="border-rounding">
      <v-data-table
        class="table row-click"
        :headers="headersDoorphone"
        :items="doorphones"
        :options.sync="options"
        :server-items-length="totalDoorphones"
        item-key="id"
        show-select
        disable-sort
        v-model="selectedDoorphone"
        @click:row="activateShowSelect"
        :footer-props="{
          'items-per-page-options': [5, 15, 20, 50, 100],
          showFirstLastPage: true,
        }"
      >
        <template v-slot:item.address="{ item }">
          {{ getDoorphoneAddress(item) }}
        </template>
        <template v-slot:item.physical_status="{ item }">
          <div>
            <v-icon v-if="item.physical_status" x-small :color="physicalStatusColor(item.physical_status)">
              mdi-checkbox-blank-circle
            </v-icon>
            {{ physicalStatus(item.physical_status) }}
          </div>
        </template>
        <template v-slot:item.agent="{ item }">
          {{ getAgentName(item.agent_id) }}
        </template>
        <template v-slot:top>
          <v-row no-gutters class="pa-5" align="center">
            <v-btn
              color="primary"
              class="text-none mr-5 mb-2"
              @click.stop="dialog = true"
              :disabled="selectedDoorphone <= 0"
              rounded
            >
              Применить действие
            </v-btn>
            <v-btn class="text-none mb-2" @click.prevent="cancelCheck" rounded>
              Отменить
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="$checkPermission('mass_upload_open_door_sound_doorphone') || $checkPermission('mass_set_sound_settings_doorphone') || $checkPermission('mass_set_lcd_settings')"
              color="primary"
              outlined
              class="text-none mb-2"
              rounded
              :to="{ name: 'MassOpenDoorSound' }"
            >
              <v-icon left>mdi-upload-multiple</v-icon>
              Загрузка на домофоны
            </v-btn>
          </v-row>
          <v-row no-gutters class="pa-3">
            <v-col cols="9" sm="6" md="4" lg="2" class="py-0 mr-5">
              <v-text-field
                v-model="filterAddress"
                label="адрес"
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-rename-box-outline"
                class="input input-search pb-2 border-rounding"
                @keyup.enter="filterDoorphones"
              />
            </v-col>
            <v-col cols="9" sm="6" md="4" lg="2" class="py-0 mr-5">
              <v-autocomplete
                v-model="filterManagementCompany"
                label="УК"
                :items="managementCompanies"
                item-text="name"
                item-value="id"
                outlined
                clearable
                dense
                hide-details
                prepend-inner-icon="mdi-home-account"
                class="pb-2 border-rounding"
                @keyup.enter="filterDoorphones"
              />
            </v-col>
            <v-col cols="9" sm="6" md="4" lg="2" class="py-0 mr-5">
              <v-autocomplete
                label="Компания-собственник"
                :items="managementsGroup"
                v-model='filterManagementGroup'
                prepend-inner-icon="mdi-account-multiple"
                item-text="name"
                item-value="id"
                type="string"
                class="border-rounding"
                outlined
                dense
                flat
                clearable
                @keyup.enter="filterDoorphones"
              />
            </v-col>
            <v-col cols="9" sm="6" md="4" lg="2" class="py-0 mr-5">
              <v-autocomplete
                v-model="filterAgent"
                label="Агент"
                prepend-inner-icon="mdi-account-search"
                :items="agents"
                item-text="user.name"
                item-value="id"
                class="border-rounding"
                outlined
                dense
                flat
                clearable
                @keyup.enter="filterDoorphones"
              />
            </v-col>
            <v-col cols="9" sm="6" md="4" lg="2" class="py-0 mr-5">
              <v-autocomplete
                v-model="filterRegion"
                label="Район"
                prepend-inner-icon="mdi-home-city"
                :items="region"
                item-text="name"
                item-value="id"
                class="border-rounding"
                outlined
                dense
                flat
                clearable
                @keyup.enter="filterDoorphones"
              />
            </v-col>
            <v-col cols="9" sm="6" md="4" lg="2" class="py-0 mr-5">
              <v-autocomplete
                v-model="filterModel"
                label="Модель"
                prepend-inner-icon="mdi-cog-outline"
                :items="model"
                item-text="name"
                item-value="id"
                class="border-rounding"
                outlined
                dense
                flat
                clearable
                @keyup.enter="filterDoorphones"
              />
            </v-col>
            <v-btn
              dark
              class="btn blue darken-3 white px-7 text-none ml-2 border-rounding"
              @click.prevent="filterDoorphones"
            >
              Поиск
            </v-btn>
            <div class="d-flex align-center ml-6 mb-7">
              <v-btn
                icon
                small
                :disabled="options.page <= 1"
                @click="goToPage(options.page - 1)"
                class="mr-1"
              >
                <v-icon small>mdi-chevron-left</v-icon>
              </v-btn>
              <span class="text-caption mx-2">{{ options.page }} / {{ Math.ceil(totalDoorphones / options.itemsPerPage) }}</span>
              <v-btn
                icon
                small
                :disabled="options.page >= Math.ceil(totalDoorphones / options.itemsPerPage)"
                @click="goToPage(options.page + 1)"
                class="ml-1"
              >
                <v-icon small>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="550" content-class="dialog-border-radius">
      <list-change-modal
        :selected-doorphone="selectedDoorphone"
        @close="dialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ListChangeModal from '@/components/massFunction/ListChangeModal';
import StatusIntercomMixin from '@/mixins/StatusIntercomMixin';

export default {
  name: 'Doorphone',
  mixins: [StatusIntercomMixin],
  components: {
    ListChangeModal,
  },
  data () {
    return {
      filterAddress: '',
      filterManagementCompany: '',
      filterManagementGroup: '',
      filterAgent: '',
      filterRegion: '',
      filterModel: '',
      totalDoorphones: 0,
      isCreated: false,
      dialog: false,
      textMessage: false,
      loading: true,
      pagination: {},
      selectedDoorphone: [],
      doorphones: [],
      filters: {},
      options: {
        itemsPerPage: 15,
        page: 1,
      },
      headersDoorphone: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address' },
        { text: 'Регион', value: 'region' },
        { text: 'Физический статус', value: 'physical_status' },
        { text: 'Диапазон квартир', value: 'diapason' },
        { text: 'Модель устройства', value: 'model' },
        { text: 'УК', value: 'management_company' },
        { text: 'Компания-собственник', value: 'management_group' },
        { text: 'Агент', value: 'agent' },
      ],
    };
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadDoorphones();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  created () {
    this.loadDoorphones();
    this.loadManagementCompanies({
      filters: { with_doorphones: 1 },
    });
    this.getManagementsGroups({ pagination: 1 })
      .then((response) => {
        this.totalCompaniesGroup = response.meta.total;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке групп управляющих компаний');
      });
    // this.loadAllAgents();
    this.loadRegions();
    this.getModels();
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      managementsGroup: 'GroupManagementCompany/managementsGroup',
      managementCompanies: 'ManagementCompany/managementCompanies',
      agents: 'Agents/agents',
      model: 'DeviceModel/models',
      region: 'Region/regions',
    }),
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getMfDoorphones',
      loadManagementCompanies: 'ManagementCompany/getManagementCompanies',
      getManagementsGroups: 'GroupManagementCompany/getManagementsGroups',
      loadAllAgents: 'Agents/loadAllAgents',
      getModels: 'DeviceModel/getModels',
      loadRegions: 'Region/getRegions',
    }),
    getAgentName (agentId) {
      const agent = this.agents.find(agent => agent.id === agentId);
      if (agent) {
        return agent.user.name;
      }
      const intercomWithStatus5 = this.doorphones.find(intercom => intercom.physical_status === 5);
      if (intercomWithStatus5) {
        return 'ООО "КОМПАНИЯ ВОЛНА"';
      }
      return 'Неизвестный агент';
    },
    loadDoorphones () {
      this.loading = true;
      this.getDoorphones({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
      })
        .then((response) => {
          this.doorphones = response.doorphones;
          this.totalDoorphones = response.meta.total;
        })
        .catch((error) => {
          console.error(error);
          this.$sentry_exception(error);
          this.$flash_warning('Ошибка при загрузке домофонов');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    filterDoorphones () {
      this.options.page = 1;
      this.filters = {};
      if (this.filterAddress) {
        this.filters.address = this.filterAddress;
      }
      if (this.filterManagementCompany) {
        this.filters.management_company_id = this.filterManagementCompany;
      }
      if (this.filterManagementGroup) {
        this.filters.management_group_id = this.filterManagementGroup;
      }
      if (this.filterRegion) {
        this.filters.region_id = this.filterRegion;
      }
      if (this.filterModel) {
        this.filters.model_id = this.filterModel;
      }
      if (this.filterAgent) {
        this.filters.agent_id = this.filterAgent;
      }
      this.loadDoorphones();
    },
    checkSize () {
      this.checkboxAllSmall = window.innerWidth <= 600;
    },
    getDoorphoneAddress (item) {
      let address = item.address;
      if (item.type === 'G') {
        address += ' (калитка)';
      }
      if (item.entrance > 0) {
        address = `${item.address}`;
        if (item.type === 'A') {
          address += ' (доп.вход)';
        }
      }
      return address;
    },
    activateShowSelect (item) {
      if (this.selectedDoorphone) {
        const index = this.selectedDoorphone.indexOf(item);

        if (index === -1) {
          this.selectedDoorphone.push(item);
        } else {
          this.selectedDoorphone.splice(index, 1);
        }
      }
    },
    cancelCheck () {
      this.selectedDoorphone = [];
    },
    goToPage (page) {
      this.options.page = page;
      this.loadDoorphones();
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card__text, .v-card__title {
  word-break: normal;
}
.row-click {
  cursor: pointer;
}
.border-rounding {
  border-radius: 16px
}
</style>
